import graphql from './graphql';

const query = /* GraphQL */ `
  query Achievement_list {
    Achievement_list {
      id
      name
      description
    }
  }
`;

const AchievementList = async () => graphql(query).then(data => data.Achievement_list);

export default AchievementList;
